import { FadeInSection } from '@/hooks/useAnimation';

const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '产地直发',
    description: '全国20+优质产区直采，从田间直达餐桌，省去中间环节，更新鲜更实惠。',
    color: 'primary',
  },
  {
    icon: 'ri-truck-line',
    title: '极速配送',
    description: '顺丰冷链战略合作，全国主要城市次日达，全程温控确保瓜果新鲜如初。',
    color: 'accent',
  },
  {
    icon: 'ri-award-line',
    title: '品质保障',
    description: '"瓜瓜优选"品质认证体系，每一颗瓜都经过专业检测，不熟不采、不好不发。',
    color: 'primary',
  },
  {
    icon: 'ri-refresh-line',
    title: '坏果包赔',
    description: '收到有任何质量问题，24小时内联系客服，核实后立刻补发或退款，购物零风险。',
    color: 'accent',
  },
];

export default function Advantages() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <FadeInSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              为什么选择瓜瓜基地？
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              从源头到服务的每一个环节，我们都用心打磨，只为给您最好的体验
            </p>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {advantages.map((adv, index) => (
            <FadeInSection key={index} delay={index * 120} direction="up">
              <div
                className="bg-background-50 rounded-2xl p-6 md:p-7 text-center group hover:-translate-y-1 transition-transform duration-300"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center ${
                  adv.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
                }`}>
                  <i className={`${adv.icon} text-2xl ${
                    adv.color === 'primary' ? 'text-primary-500' : 'text-accent-500'
                  }`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{adv.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{adv.description}</p>
              </div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}